import { useMutation } from "@apollo/client";
import { USE_VSME_REPORT } from "@services/graphql/mutations/useVsmeReport";
import { FETCH_SUBSCRIPTION_INFO } from "@company/graphql/queries/fetchSubscriptionInfo";

/**
 * Hook zum Einreichen eines VSME-Report-Jobs.
 */
export const useVsmeReport = () => {
    const [triggerMutation, { loading, error, data }] = useMutation(USE_VSME_REPORT, {
        refetchQueries: [FETCH_SUBSCRIPTION_INFO],
    });

    const submitJob = async (documents: string[] = []) => {
        const result = await triggerMutation({ variables: { documents } });
        return result.data?.useVsmeReport ?? null;
    };

    return {
        submitJob,
        loading,
        error,
        job: data?.useVsmeReport ?? null,
    } as const;
}; 